import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronLargeRight"><Path fillRule="evenodd" clipRule="evenodd" d="M9.23307 2.07732C9.46654 1.92986 9.77535 1.99959 9.92281 2.23307L15.2483 10.6651C15.7633 11.4805 15.7633 12.5195 15.2483 13.335L9.92281 21.7671C9.77535 22.0005 9.46654 22.0703 9.23307 21.9228C8.99959 21.7754 8.92986 21.4665 9.07732 21.2331L14.4028 12.801C14.7118 12.3117 14.7118 11.6883 14.4028 11.1991L9.07732 2.76706C8.92986 2.53359 8.99959 2.22478 9.23307 2.07732Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeRight;
